import script from "./AssessmentBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentBlock.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentBlock.vue?vue&type=style&index=0&id=b74a0ff6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b74a0ff6"]])

export default __exports__